import React from 'react';

export default class VisualizeIcon extends React.Component {
  render() {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 17.5 17.5'>
        <rect x='0.8' y='8.8' width='8' height='8' />
        <rect x='8.8' y='8.8' width='8' height='8' />
        <rect x='8.8' y='0.8' width='8' height='8' />
      </svg>
    );
  }
}
